import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import SideBarContainer from "../render-cpn/render-nav";
import { useState } from "react";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SideBar = (props) => {
  const { lang, pages, auth: user } = useSelector((state) => state);
  const { is_public } = props;

  return (
    !is_public && (
      <nav id="sidebar">
        <div class="sidebar_blog_1">
          <div class="sidebar-header">
            <div class="logo_section">
              <a href="/">
                <img
                  class="logo_icon img-responsive"
                  src="/images/logo/logoDPM2.png"
                  alt="Logo"
                  style={{
                    width: "100%",
                    objectFit: "contain",
                    background: "white",
                  }}
                />
              </a>
            </div>
          </div>
          <div
            class="sidebar_user_info sidebar_user_info_custom d-flex"
            style={{
              // paddingLeft: "40px"
              //DPM
              alignItems: "center",
              background: "white !important",
            }}
          >
            <img
              class="img-responsive m-0 mr-2"
              src="/images/logo/logoDPM_02.png"
              alt="Logo"
              style={{ height: "50px", objectFit: "fill", width: "" }}
              loading="lazy"
            />
            <div class="icon_setting"></div>
            <div class="user_profle_side justify-content">
              <div class="logo_section d-flex align-items-center">
                <a href="/"></a>
                {/* <div
                  className="slogan ml-2"
                  style={{ textTransform: "uppercase" }}
                >
                  <div
                    className="t1"
                    style={{ 
                      fontSize: "10px",
                      lineHeight: "20px",
                      color: "rgb(35, 72, 125)",
                      textTransform: "uppercase",
                    }}
                  >
                    tập đoàn dầu khí quốc gia
                  </div>
                  <div
                    className="t2"
                    style={{
                      fontSize: "10px",
                      lineHeight: "20px",
                      color: "#047746",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      color: "rgb(35, 72, 125)",
                    }}
                  >
                    tổng công ty <br />
                    phân bón và hóa chất dầu khí
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div class="block-nav">
          <div class="sidebar_blog_2">
            <ul class="list-unstyled components">
              {user.role === "pm" ? (
                <li className="navbar-item">
                  <NavLink to="/" activeClassName="nav-active">
                    <i class="fa fa-upload size-24 icon-import-nav"></i>
                    <span>Import</span>
                  </NavLink>
                </li>
              ) : null}
              {user.role === "pm" ? (
                <li className="navbar-item">
                  <NavLink to="/active" activeClassName="nav-active">
                    <i class="fa fa-key purple_color3"></i>
                    <span>{lang["activation"]}</span>
                  </NavLink>
                </li>
              ) : null}

              {user.role === "pm" ||
              user.role === "uad" ||
              user?.ct?.find(
                ({ table_alias, read }) => table_alias === "accounts" && read
              ) ? (
                <li className="navbar-item">
                  <NavLink to="/users" activeClassName="nav-active">
                    <i class="fa fa-users icon-user"></i>
                    <span>{lang["accounts manager"]}</span>
                  </NavLink>
                </li>
              ) : null}

              {/* {user.role === "pm" || user.role === "uad" ? (
                <li className="navbar-item">
                  <NavLink to="/privileges" activeClassName="nav-active">
                    <i class="fa fa-lock icon-privileges"></i>

                    <span>{lang["privileges manager"]}</span>
                  </NavLink>
                </li>
              ) : null} */}

              {["pm", "uad"].includes(user?.role) ||
              user?.ct?.find(
                ({ table_alias, read }) =>
                  table_alias === "privilegegroup" && read
              ) ? (
                <li className="navbar-item">
                  <NavLink to="/privileges/groups" activeClassName="nav-active">
                    <i class="fa fa-users icon-privileges"></i>
                    <span>{lang["privileges groups"]}</span>
                  </NavLink>
                </li>
              ) : null}

              {user.role === "uad" || user.role === "pm" ? (
                <li>
                  <a
                    href="#"
                    // onClick={toggleMenu}
                    // aria-expanded="false"
                    // class="dropdown-toggle"
                  >
                    <i class="fa fa-dashboard yellow_color"></i>
                    <span>{lang["data management"]}</span>
                    <FontAwesomeIcon
                      className="ml-2"
                      icon={faCaretDown}
                      transform={{ rotate: 270 }}
                    />
                  </a>
                  {/* <ul
                    className={`collapse list-unstyled  scrollable`}
                    id="dashboard"
                  >
                    {pages &&
                      pages.map((ui, index) =>
                        ui.status ? (
                          <li key={index} className="navbar-item">
                            <NavLink
                              to={`/page${ui.url}`}
                              activeClassName="nav-active"
                            >
                              <i class="fa fa-newspaper-o"></i>
                              <span>{ui.title}</span>
                            </NavLink>
                          </li>
                        ) : null
                      )}
                  </ul> */}
                </li>
              ) : null}
              {pages.length && (
                <SideBarContainer
                  pages={pages.filter(({ is_hidden }) => !is_hidden)}
                />
              )}
              {/* <Navbar_Render
                data={pages}
                isLogged={isLogged}
                privilegesGroup={privileges}
                user={user}
              /> */}
              {/* <li className="navbar-item">
                <NavLink to="/stats" activeClassName="nav-active">
                  <FontAwesomeIcon className="mr-3" icon={faCaretRight} fontSize={20}/>
                  <span>Thống Kê Kho</span>
                </NavLink>
              </li> */}
              {/* {user.role === "uad" || user.role === "pm" ? ( */}
              <>
                {user.role === "uad" || user.role === "pm" ? (
                    <li className="navbar-item">
                      <NavLink to="/SyncData" activeClassName="nav-active">
                        <i class="fa fa-calendar pointer icon-database"></i>
                        <span>Đặt Lịch API</span>
                      </NavLink>
                    </li>
                  ) : null}
                {/* {user.role === "uad" && (
                  <li className="navbar-item">
                    <NavLink to="/diagram_db" activeClassName="nav-active">
                      <i class="fa fa-database pointer icon-database"></i>
                      <span>{lang["diagram"]}</span>
                    </NavLink>
                  </li>
                )} */}
                <li className="navbar-item">
                  <NavLink to="/sitemap" activeClassName="nav-active">
                    <i class="fa fa-sitemap"></i>
                    <span>{lang["site map"]}</span>
                  </NavLink>
                </li>
                <li className="navbar-item">
                  <NavLink to="/version" activeClassName="nav-active">
                    <i class="fa fa-code-fork"></i>
                    <span>{lang["version"]}</span>
                  </NavLink>
                </li>
                {/* {isLogged ? (
                    <li className="navbar-item">
                      <NavLink to="/logs" activeClassName="nav-active">
                        <i class=" fa fa-shield"></i>
                        <span>{lang["log.login"]}</span>
                      </NavLink>
                    </li>
                  ) : null} */}
              </>
              {/* ) : null} */}
              {/* {isLogged && ["pm", "uad"].includes(user.role) ? ( */}
              <>
                <li className="navbar-item">
                  <NavLink to="/history" activeClassName="nav-active">
                    <i class=" fa fa-shield"></i>
                    <span>{lang["log.login"]}</span>
                  </NavLink>
                </li>
              </>
              {/* ) : null} */}
            </ul>
          </div>
        </div>
        <div class="footer-custom p-2">
          <span>
            &copy; {new Date().getFullYear()} - Designed by Mylan Group
          </span>
          <span> Phiên bản: 1.0.2.1</span>
        </div>
      </nav>
    )
  );
};
export default SideBar;
